import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/layout.css";
import "../css/login.css";
import findGif from "../css/loading_old.gif";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from "../store/allApi";

export default function Login() {


  const history = useHistory();
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const { referralcode } = useParams();

  const [Phone, setPhone] = useState();
  const [twofactor_code, settwofactor_code] = useState();
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [time, setTime] = useState(new Date());

  let refs = useLocation().pathname.split("/")[2];
  const [referral, setReferral] = useState(refs);

  const handleClick = async (e) => {

    e.preventDefault();
    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
    } else if (Phone.length != 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please  enter currect phone number",
      });
    } else {
      setIsloading1(true);
      let newTime = String(Date.now())

      try {
        const respone = await apiRequest(`login`, "POST", { Phone, referral, newTime }, null)
        if (respone) {
          setIsloading1(false);
          if (respone.data.status == 101) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: respone.data.msg,
            });
          } else if (respone.data.status == 429) {
            const waitSec = respone.data.retryAfter || respone.data.otpResendSeconds || 45;
            setResendLeft(waitSec);
            Swal.fire({
              icon: "info",
              title: "Please wait",
              text: `Please wait before requesting a new OTP (${waitSec}s)`,
            });
          } else if (respone.data.status == 200) {
            const expireSeconds = respone.data.otpExpireSeconds || 120;
            const resendSeconds = respone.data.otpResendSeconds || 45;
            setOtp(true);
            setExpireLeft(expireSeconds);
            setResendLeft(resendSeconds);
            setSecretCode(respone.data.secret);
            if (respone.data.myToken) {
              Swal.fire({
                icon: "success",
                title: "OTP",
                text: "Demo Account Testing OTP: " + respone.data.myToken,
              });
            }
          }
          else if (respone?.data?.msg == 'Currently we are not allowing new registration.') {
            Swal.fire({
              icon: "warning",
              title: "Important Notice",
              html: `
                <p style="font-size:14px; color:#333; margin-bottom:15px;">
                 As per recent development pertaining to 
               <b>"The Promotion and Regulation of Online Gaming Bill, 2025"</b>, 
                we are pausing all operations as of now. We shall inform you till any update.
                 </p>

               <div style="background:#e6f9ec; color:#006600; padding:10px; border-radius:6px; margin-bottom:10px; font-size:13px;">
               ✅ Your amount is safe with us. You can withdraw all your winning directly to your Bank account.
               </div>

                <div style="background:#f0f6ff; color:#004080; padding:10px; border-radius:6px; font-size:13px;">
                ℹ️ Further money in your deposit wallet will be made available within 48 hours in your winning wallet for withdrawals.
                </div>
               `,
              background: "#fff",
              color: "#000",
              showCloseButton: true,
              confirmButtonText: "I Understand",
              confirmButtonColor: "#006633", // green button
              customClass: {
                popup: "rounded-xl shadow-lg p-3",
                title: "text-lg font-bold mb-2",
                confirmButton: "px-6 py-2 rounded-lg font-medium"
              }
            });
          }
          else if (respone?.data?.msg == "Currently we are not allowing user to Login") {
            Swal.fire({
              icon: "info",
              title: "Important Notice",
              text: respone?.data?.msg,

            });
          }
        }
      } catch (e) {
        setIsloading1(false);
        const retryAfter = e?.response?.data?.retryAfter;
        if (retryAfter) {
          setResendLeft(retryAfter);
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: retryAfter
            ? `Please wait before requesting a new OTP (${retryAfter}s)`
            : (e?.response?.data?.msg || "Something went wrong"),
        });
      }
    }
  };


  const varifyOtp = async (e) => {
    e.preventDefault();

    if (!Phone) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your phone number",
      });
      return;
    }
    setIsloading1(true);

    try {
      const finishBody = { Phone, twofactor_code }
      if (referral != null && referral !== '') finishBody.referral = referral
      if (secretCode != null && secretCode !== '') finishBody.secretCode = secretCode
      const response = await apiRequest(`login/finish`, "POST", finishBody)
      setIsloading1(false);

      if (response.data.status === 101) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.msg,
        });
      } else if (response.data.status === 200) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        // Reload the page and redirect after a delay
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games"); // Assuming you have 'history' available
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!" + response.data.status + "",
        });
      }

    }
    catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    }
  };

  const [expireLeft, setExpireLeft] = useState(0);
  const [resendLeft, setResendLeft] = useState(0);

  useEffect(() => {
    if (!otp) return undefined;
    const timerInterval = setInterval(() => {
      setExpireLeft((prev) => (prev > 0 ? prev - 1 : 0));
      setResendLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timerInterval);
  }, [otp]);

  const handleResendClick = (e) => {
    if (resendLeft > 0) return;
    handleClick(e);
  };
  return (
    <>
      <div className="leftContainer" style={{ minHeight: "100vh" }}>
        <div className="login_main-area ">
          
          <div style={{ width: "90%" }}>
           
          </div>
          <div className="login_box_main_box  center-xy mx-auto">
            <div className="form_haeding">Sign in</div>

            <div className="login_input_field_main">
              <div className="login_input_field_inner">
                <span>+91</span>
                <input
                  className="form_control"
                  name="mobile"
                  type="tel"
                  placeholder="Mobile number"
                  onChange={(e) => {
                    setPhone(e.target.value);
                    if (e.target.value.length > 10) {
                      // setError(true)
                    }
                  }}
                />
              </div>
            </div>

            {otp && (
              <>
                <div className="login_input_field_main otp_filed">
                  <div className="login_input_field_inner">
                    <span>OTP</span>
                    <input
                      className="form_control input_filed"
                      name="password"
                      type="tel"
                      placeholder="Enter OTP"
                      onChange={(e) => settwofactor_code(e.target.value)}
                    />
                  </div>
                </div>
                <div className="resend_otp_div">
                  <p className="otp_expire">
                    {expireLeft > 0
                      ? `OTP expires in ${expireLeft} seconds.`
                      : "OTP expired. Resend to get a new code."}
                  </p>
                  {resendLeft > 0 ? (
                    <p className="otp_expire">Resend in {resendLeft} seconds.</p>
                  ) : (
                    <button type="button" onClick={handleResendClick}>
                      Resend OTP
                    </button>
                  )}
                </div>
              </>
            )}

            {!otp &&
              (isLoading1 ? (
                <button
                  className="Login-button cxy"
                  disabled
                >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </button>
              ) : (
                <button
                  className="Login-button cxy "
                  onClick={(e) => {
                    handleClick(e);
                  }}
                >
                  Get OTP
                </button>
              ))}

            {otp &&
              (isLoading1 ? (
                <button
                  className="Login-button cxy"
                  disabled
                >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </button>
              ) : (
                <button
                  className="Login-button cxy"
                  onClick={(e) => varifyOtp(e)}
                >
                  Verify
                </button>
              ))}
          </div>
          <div className="login-footer mb-5">
            By continuing I agree that Empire Ludo may store and process my data in accordance with the Contact Privacy Policy and that I am 18 years or older. I am not playing from Assam, Odisha, Nagaland, Sikkim, Meghalaya, Andhra Pradesh, or Telangana.
          </div>
        </div>
      </div>
    </>
  );

}